import { Box, Button, Flex, FormControl, FormErrorMessage, Input } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSignUpModel } from '../../models/SignUpModel';
import { PageHeader } from './PageHeader';

type FormValues = {
  firstName: string;
  lastName: string;
};

export const NameForm: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { firstName, lastName, setName } = useSignUpModel();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  const onSubmit = handleSubmit(async (data) => {
    setIsLoading(true);
    setName(data.firstName, data.lastName);
    setIsLoading(false);
  });

  return (
    <Flex direction={'column'} gap={10} align="center">
      {/* Header */}
      <PageHeader
        title="Now, what is your full name?"
        subtitle="We're required to get your legal first and last name"
        step={3}
        steps={4}
      />

      {/* Form */}
      <Box as="form" onSubmit={onSubmit} minW={['100%', '350px']}>
        <FormControl
          isInvalid={Boolean(errors.firstName)}
          mb={5}
          as={Flex}
          alignItems={'center'}
          flexDir={'column'}
          justifyContent={'center'}>
          <Input
            id="firstName"
            mb={3}
            placeholder="Legal First Name"
            maxW={['full', 350]}
            {...register('firstName', {
              minLength: {
                message: 'First name must be at least 2 characters',
                value: 2,
              },
              required: 'Please enter a first name',
            })}
            defaultValue={firstName}
            autoFocus={true}
          />
          <FormErrorMessage>{errors.firstName && errors.firstName.message}</FormErrorMessage>
        </FormControl>
        <FormControl
          isInvalid={Boolean(errors.firstName)}
          mb={5}
          as={Flex}
          alignItems={'center'}
          flexDir={'column'}
          justifyContent={'center'}>
          <Input
            id="lastName"
            mb={3}
            placeholder="Legal Last Name"
            maxW={['full', 350]}
            {...register('lastName', {
              minLength: {
                message: 'Last name must be at least 2 characters',
                value: 2,
              },
              required: 'Please enter a last name',
            })}
            defaultValue={lastName}
          />
          <FormErrorMessage>{errors.lastName && errors.lastName.message}</FormErrorMessage>
        </FormControl>
        <Button
          isDisabled={Boolean(errors.firstName) || Boolean(errors.lastName) || isLoading}
          isLoading={isLoading}
          type="submit"
          w="full"
          p={7}
          maxW={'full'}>
          Continue
        </Button>
      </Box>
    </Flex>
  );
};
